module.exports = __webpack_public_path__ + "static/media/about.a90891df.jpg";